import { supabase } from '@/integrations/supabase/client';
import { logger } from '@/utils/logger';

/**
 * Restart quiz generation for modules that need it
 */
export async function restartQuizGeneration() {
  try {
    logger.info('🚀 Starting quiz generation...');

    // Check for existing in-progress operation
    const { data: existingOp } = await supabase
      .from('quiz_generation_operations')
      .select('*')
      .eq('status', 'in_progress')
      .order('created_at', { ascending: false })
      .limit(1)
      .maybeSingle();

    if (existingOp) {
      logger.info('🔄 Continuing existing operation:', existingOp.id);
      const { data, error } = await supabase.functions.invoke('bulk-generate-quizzes', {
        body: { 
          action: 'continue',
          operationId: existingOp.id
        }
      });

      if (error) throw error;

      return {
        success: true,
        operationId: existingOp.id,
        message: 'Continuing quiz generation'
      };
    }

    // Start new operation
    const { data, error } = await supabase.functions.invoke('bulk-generate-quizzes', {
      body: { action: 'start' }
    });

    if (error) throw error;

    logger.info('✅ Quiz generation started', data);
    return {
      success: true,
      operationId: data.operationId,
      message: 'Quiz generation started'
    };

  } catch (error) {
    logger.error('❌ Failed to start quiz generation:', error);
    throw error;
  }
}

/**
 * Monitor quiz generation progress
 */
export async function monitorQuizProgress(operationId: string) {
  try {
    const { data, error } = await supabase
      .from('quiz_generation_operations')
      .select('*')
      .eq('id', operationId)
      .single();

    if (error) throw error;

    return {
      operationId: data.id,
      status: data.status,
      progress: {
        total: data.total_modules,
        processed: data.processed_modules,
        successful: data.successful_modules,
        failed: data.failed_modules,
        percentage: Math.round((data.processed_modules / data.total_modules) * 100)
      }
    };
  } catch (error) {
    logger.error('❌ Failed to monitor quiz progress:', error);
    throw error;
  }
}
